<template>
  <b-modal
    id="activation-code-forget-password-real-person"
    hide-footer
    hide-header
    no-stacking
    no-close-on-esc
    no-close-on-backdrop
    @shown="firstShow"
  >
    <template>
      <!-- Close Button Container -->
      <div class="close-button-container">
        <span class="close-button" @click="hide()">&times;</span>
        <br />
      </div>
      <!-- End Close Button Container -->

      <!-- Modal Main Content -->
      <div class="modal-main-content">
        <!-- Logo -->
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="roshd logo" />
        </div>
        <!-- End Logo -->

        <!-- Title -->
        <div class="heading mb-4">
          <h6>راستی آزمایی شماره موبایل</h6>
        </div>
        <!-- End Title -->

        <!-- Question -->
        <b-overlay
          :show="showSend"
          rounded="sm"
          opacity="1"
          variant="transparent"
        >
          <template v-slot:overlay>
            <div class="text-center">
              <b-icon
                icon="stopwatch"
                font-scale="4"
                animation="cylon"
              ></b-icon>
              <p id="cancel-label">شکیبا باشید</p>
            </div>
          </template>
          <div class="question">
            <p class="text-dove-gray">کد فعال سازی را وارد کنید</p>
          </div>
          <!-- End Question -->

          <!-- Form -->
          <form class="activation-code-form d-flex flex-column" autocomplete="off">

            <!-- Codes -->
            <div class="codes d-flex justify-content-between">
              <input
                      type="text"
                      name="code5"
                      maxlength="1"
                      ref="inp5"
                      v-model.trim="code.inp5"
                      :disabled="showSend"
                      placeholder="__"
              />
              <input
                      type="text"
                      name="code4"
                      maxlength="1"
                      ref="inp4"
                      v-model.trim="code.inp4"
                      placeholder="__"
              />
              <input
                      type="text"
                      name="code3"
                      maxlength="1"
                      ref="inp3"
                      v-model.trim="code.inp3"
                      placeholder="__"
              />
              <input
                      type="text"
                      name="code2"
                      maxlength="1"
                      ref="inp2"
                      v-model.trim="code.inp2"
                      placeholder="__"
              />
              <input
                      type="text"
                      name="code1"
                      maxlength="1"
                      ref="inp1"
                      v-model.trim="code.inp1"
                      placeholder="__"
              />
            </div>
            <!-- End Codes -->

            <!-- Captcha -->
            <div class="captcha position-relative mt-4">
              <p class="font-size-12 mb-2">کد زیر را وارد کنید</p>
              <div class="captcha-box">
                <img :src="`${urlCap + captchaImg}`" alt="captcha" />
                <div
                        class="form-group mb-0"
                        :class="{ 'form-group--error': $v.captcha.$error }"
                >
                  <input
                          type="text"
                          name="captcha"
                          ref="captcha"
                          autocomplete="off"
                          v-model.trim="captcha"
                          @input="delayTouch($v.captcha)"
                  />
                  <div
                          class="error captcha-required-error"
                          v-if="!$v.captcha.required"
                  >
                    وارد نمودن کد 4 حرفی الزامی است.
                  </div>
                </div>
              </div>
            </div>
            <!-- End Captcha -->

          </form>
          <!-- End Form -->

          <!-- Countdown -->
          <div class="countdown text-center mt-5 mb-3 text-dove-gray">
            <b-overlay
              :show="showCode"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block"
            >
              <button
                type="button"
                class="btn btn-secondary"
                :disabled="counting"
                @click.prevent="startCountdown"
              >
                <countdown v-if="counting" :time="time" @end="counting = false">
                  <template slot-scope="props"
                    >{{ props.minutes }}:{{ props.seconds }}</template
                  >
                </countdown>
                <span v-else>ارسال مجدد کد</span>
              </button>
            </b-overlay>
          </div>
        </b-overlay>

        <!-- End Countdown -->
      </div>
      <!-- End Modal Main Content -->
    </template>
  </b-modal>
</template>

<script>
import axios from "@/axios.js";
import { url, formErrors } from "@/mixins.js";
import {minLength, required} from "vuelidate/lib/validators";

export default {
  name: "ActivationCodeForgetPasswordRealPerson",
  mixins: [url, formErrors],
  data() {
    return {
      counting: true,
      time: 179999,
      showSend: false,
      showCode: false,
      code: {
        inp1: "",
        inp2: "",
        inp3: "",
        inp4: "",
        inp5: "",
      },
      captchaImg: "",
      captcha: "",
    };
  },
  computed: {
    phoneNumber() {
      let phone = `${this.phone}`;
      let star = phone[4] + phone[5] + phone[6] + phone[7];
      let str = "0" + phone.replace(star, "****");
      return str;
    },
    urlCap() {
      return `${this.basicUrl}assets/images/captcha/`;
    },
  },
  methods: {
    hide(){
      this.$root.$emit("bv::hide::modal", "activation-code-forget-password-real-person");
    },

    createCaptcha() {
      let data = new FormData();
      data.append("action", "create_captcha");

      axios
              .post("captcha/create.php", data)
              .then((data) => {
                this.captchaImg = data.data + ".png";
                this.captcha = "";
              })
              .catch((err) => console.error("Err lang :", err));
    },

    async startCountdown() {
      this.showCode = true;

      await axios
        .post(`user/auth/request_resend_code.php`)
        .then((data) => {
          switch (data.data.msg) {
            case "sent":
              this.$snotify.success("کد فعال سازی به شماره شما ارسال شد.");

              for (let m in this.code) {
                this.code[m] = "";
              }
              this.$refs.inp1.focus();
              this.counting = true;
              break;

            case "failure":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "validate_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "session_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            default:
              this.$snotify.warning("خطایی رخ داده، دوباره تلاش کنید");
          }
        })
        .catch((err) =>
          console.error("Response Error request_resend_code::", err)
        );

      this.showCode = false;
    },

    firstShow() {
      this.createCaptcha();
      this.$refs.inp1.focus();
    },

    async sendCode() {
      this.showSend = true;

      let code =
        this.code.inp1 +
        this.code.inp2 +
        this.code.inp3 +
        this.code.inp4 +
        this.code.inp5;

      let data = new FormData();
      data.append("code", code);
      data.append("captcha", this.captcha);

      await axios
        .post("user/auth/forget-pwd/verify_code.php", data)
        .then((data) => {

          switch (data.data.msg) {
            case "empty_err":
              if (data.data.state == "ip_blacklist") {
                this.$snotify.warning(this.errors[data.data.state]);
              } else {
                this.$snotify.warning(this.errors[data.data.msg]);
              }
              break;

            case "create_captcha":
              if (data.data.state == "ip_blacklist") {
                this.$snotify.warning(this.errors[data.data.state]);
                this.createCaptcha();
              } else {
                this.$snotify.warning(this.errors[data.data.msg]);
              }
              break;

            case "session_err":
              this.$snotify.warning(this.errors[data.data.msg]);
              break;

            case "expired":
              if (data.data.state == "ip_blacklist") {
                this.$snotify.warning(this.errors[data.data.state]);
              } else {
                this.$snotify.warning(this.errors[data.data.msg]);
              }
              break;

            case "success":
              this.$snotify.success("عملیات با موفقیت انجام شد.");
              this.$root.$emit("bv::show::modal", "reset-password-real-person");
              break;

            default:
              this.$snotify.warning(
                this.errors[data.data.msg] || "مشکلی رخ داده دوباره تلاش کنید."
              );
          }

          if (data.data.captcha) {
            this.createCaptcha();
          }

          this.resetForm();
        })
        .catch((err) => console.error("Response Error verify_code::", err));

      this.showSend = false;
    },

    resetForm() {
      this.code = {
        inp1: "",
        inp2: "",
        inp3: "",
        inp4: "",
        inp5: ""
      };

      this.captcha = '';
    }
  },
  watch: {
    "code.inp1"(e) {
      if (e.length == 0) return;
      this.$refs.inp2.focus();
    },

    "code.inp2"(e) {
      if (e.length == 0) return;
      this.$refs.inp3.focus();
    },

    "code.inp3"(e) {
      if (e.length == 0) return;
      this.$refs.inp4.focus();
    },

    "code.inp4"(e) {
      if (e.length == 0) return;
      this.$refs.inp5.focus();
    },

    "code.inp5"(e) {
      if (e.length == 0) return;

      if(this.captcha.trim().length >= 4) {
        this.sendCode();
      } else {
        this.$refs.captcha.focus();
      }

    },

    "captcha"() {
      if(
          this.code.inp1.trim() != '' &&
          this.code.inp2.trim() != '' &&
          this.code.inp3.trim() != '' &&
          this.code.inp4.trim() != '' &&
          this.code.inp5.trim() != '' &&
          this.captcha.trim().length >= 4
      ) {
        this.sendCode();
      }
    }
  },
  validations: {
    captcha: {
      required,
      minLength: minLength(4),
    }
  },
};
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>